import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import MenuList from "@mui/material/MenuList";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Box from "@mui/material/Box";

import AddIcon from "@mui/icons-material/Add";

import NoteDialog from "../../UserTimeline/Note/NoteDialog";
import SurveyDialog from "./SurveyDialog";
import ButtonOptionsDialog from "./ButtonDialog/ButtonOptionsDialog";
import SurveyButtonDialog from "./ButtonDialog/SurveyButtonDialog";
import CounterButtonDialog from "./ButtonDialog/CounterButtonDialog";
import AppContext from "../../appContext";
import { useTranslation } from "react-i18next";
import { interactions } from "./interactions";
import { FilledIconButton } from "../../Components/FilledIconButton";
import Protocol from "../Protocol";

const initCreateDialog = { open: false, type: "" };
export default function Create() {
  const { t } = useTranslation();
  const pathHistory = useHistory();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const openMenuCreate = Boolean(anchorEl2);
  const [createDialog, setCreateDialog] = useState(initCreateDialog);
  const {
    app: {
      client: { writeAccess },
    },
  } = useContext(AppContext);

  // Menu create
  const handleOpen = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose = (event, reason) => {
    if (createDialog.type === "protocol" && reason && reason == "backdropClick")
      return;
    setAnchorEl2(null);
    setCreateDialog(initCreateDialog);
  };

  // open the dedicated dialog
  const handleOption = (optionId) => {
    setCreateDialog({ open: true, type: optionId });
  };

  const handleItemClick = (optionId) => {
    setAnchorEl2(null);
    handleOption(optionId);
    if (optionId === "moodboard") pathHistory.push({ pathname: "/analyser" }); // redirect to the moodboard editor
  };

  return (
    <React.Fragment>
      {!mobile ? (
        <Button
          aria-label="create a new item"
          aria-controls="menu-create-item"
          aria-haspopup="true"
          onClick={handleOpen}
          variant="contained"
          color="primary"
          size="large"
          style={{ margin: "auto" }}
          startIcon={<AddIcon />}
        >
          {t("create.title")}
        </Button>
      ) : null}
      {mobile ? (
        <FilledIconButton
          size="medium"
          onClick={handleOpen}
          icon={<AddIcon sx={{ color: "white" }} fontSize="small" />}
          bgcolor={theme.palette.primary.main}
        />
      ) : null}

      <Menu
        anchorEl={anchorEl2}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableScrollLock={true}
        open={openMenuCreate}
        onClose={handleClose}
      >
        <MenuList>
          {interactions.map((option) =>
            option.visible ? (
              <MenuItem
                key={option.id}
                onClick={() => handleItemClick(option.id)}
                disabled={option.disabledIfNoAccess && !writeAccess}
              >
                <Box display="flex" sx={{ gap: 2, alignItems: "center" }}>
                  <Box
                    sx={{
                      backgroundColor: `items.${[option.id]}`,
                      color: "#fff",
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      borderRadius: "50%",
                      width: "32px",
                      height: "32px",
                    }}
                  >
                    {<option.icon />}
                  </Box>
                  <Box>
                    <Typography variant="body2">
                      {t(`create.${option.id}`)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t(`create.${option.id}Help`)}
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            ) : null
          )}
        </MenuList>
      </Menu>
      <React.Fragment>
        {createDialog.type === "survey" ? (
          <SurveyDialog open={createDialog.open} handleClose={handleClose} />
        ) : null}
        {createDialog.type === "button" ? (
          <ButtonOptionsDialog
            open={createDialog.open}
            handleClose={handleClose}
            handleOption={handleOption}
          />
        ) : null}
        {createDialog.type === "surveyButton" ? (
          <SurveyButtonDialog
            open={createDialog.open}
            handleClose={handleClose}
          />
        ) : null}
        {createDialog.type === "counterButton" ? (
          <CounterButtonDialog
            open={createDialog.open}
            handleClose={handleClose}
          />
        ) : null}
        {createDialog.type === "note" ? (
          <NoteDialog open={createDialog.open} handleClose={handleClose} />
        ) : null}
        {createDialog.type === "protocol" ? (
          <Protocol open={createDialog.open} handleClose={handleClose} />
        ) : null}
      </React.Fragment>
    </React.Fragment>
  );
}
